<template>
    <div class="brands" v-if="loaded && ready">
      <transition name="fade">
      <div class="main-brands">


        <div v-for="(item, index) in customers" class="brand-item" :class="{'vis' :  offSet.last >= index}"  >

          <div class="container"  v-on:click="openAcco(index)">
            <div class="brand-item-title" :class="[{'hascases' : item.cases} , {'open': itemOpen === index}]">
              <div class="btn" v-if="item.cases"></div>
              <h1>   {{item.name}}</h1>
            </div>

          </div>


          <div class="brands-cases-box" v-if="item.cases"  :class="{'open': itemOpen === index}" >
            <brands-cases :cases="item.cases" :isMobile="isMobile"></brands-cases>
          </div>




          <!--media-type></media-type-->

        </div>

        <div style="height: 50px;">

        </div>

        <div class="project-footer">
          <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
        </div>

      </div>




      </transition>

    </div>
</template>

<script>


import {NavEvents} from "../dataModules/NavEvents";
    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../main';

    import FooterNossa from "./FooterNossa";

import MediaType from "./Modules/MediaType";
import BrandsCases from "./Modules/BrandsCases";



    export default {

        name: 'brands',
      components: {BrandsCases, MediaType, FooterNossa},
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {

              customers: [],

              loaded: false,
              ready: false,


              incPagePos: 0,
              stopInc: false,


              footerVisited : '',
              main: {},
              stopSwipe: false,
              doneScreen: '',

              offSet: {
                vis: [],
                tops: [],
                last: -1
              },
              hasFooter: false,
              itemOpen: 9999

            }
        },


      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'Marcas'
          }
        },


      },
      created() {

          const _this = this;

        WP('customers', function (response){

         // console.log(response)

/*


                */

          let arrTemp = [];
          for(let k = 0; k < response.length; k ++) {


            if(!response[k].hidden){
              arrTemp.push(response[k])
            }


          }

          _this.customers = arrTemp.sort(function(a, b) {
            if(a.name < b.name) {
              return -1;
            } else {
              return true;
            }
          });

         //   console.log(_this.customers)
          _this.loaded = true;



          /*
          _this.simpleBlock = _this.aboutData['simple-block'];
          _this.listBlock = _this.aboutData['list-block'];
          _this.processBlock = _this.aboutData['process-block'];
          console.log(_this.aboutData)


           */

          _this.init();


        });

      },
      mounted() {
        this.ready = true;
        this.init();
        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);
        $(window).scrollTop(0);
        $('body, html').scrollTop(0);
      },

      destroyed() {

      },

      methods: {

        init() {

          const _this = this;

          if(_this.loaded && _this.ready){







            setTimeout(function(){

              _this.initScroll();





            },500);

          }



        },



        initScroll(){
          const _this = this;


          setTimeout(() =>{

            $('.container').each(function(i){

              _this.offSet.tops.push($(this).offset().top);

            });

            $( window ).scroll(function(e) {

              _this.scrollEvt()
            });

            $( window ).resize(function() {
              _this.reseizeMe();
            });

            _this.reseizeMe();
            _this.scrollEvt();

          }, 100)




        },

        reseizeMe() {

          this.scrollEvt()
        },

        scrollEvt() {

          const _this = this;

          _this.offSet.act =  $( window ).scrollTop() +  $( window ).height();


          // EVENTBUS.$emit('resetTeam' );

          $('.container').each(function(i){

            //  _this.offSet.tops[i].top = $(this).offset().top;


            if(_this.offSet.act > (_this.offSet.tops[i]  + 50 )&&  !_this.offSet.vis[i]) {

              _this.offSet.last = i;
              _this.offSet.vis[i] = true;




            }



          });




          //    EVENTBUS.$emit('resetTeam');


          //EVENTBUS.$emit('log', _this.offSet.tops[0]);






          console.log(_this.offSet.last)



          if(_this.offSet.last >= ($('.container').length - 1) &&  !_this.hasFooter){

            EVENTBUS.$emit('showFooter');
            _this.hasFooter=true;
            console.log('showFooter');
          }




          /*



          if(this.offSet.act > this.offSet.off2.top &&  !this.offSet.vis2) {
            this.offSet.vis2 = true;

          }
*/



          // $( window ).scrollTop()
          // console.log(this.offSet );
        },


        openAcco(n){

          if(this.itemOpen != 9999){
            this.itemOpen = 9999;
          }else{
            this.itemOpen = n;
          }



        }




      },
    };

</script>


// WEBPACK FOOTER //
// src/components/Brands.vue